import React from "react";
import EvacuationPage from "./views/EvacuationPage";
import { EvacuationContextProvider } from "./EvacuationView";
import StatusContents from "../../constants/contentFile.json";

const EvacuationView = () => {
  return (
    <EvacuationContextProvider>
      <EvacuationPage textContents={StatusContents.status} />
    </EvacuationContextProvider>
  );
};
export default EvacuationView;
